export default __webpack_public_path__ + "static/media/Cathy.535181bd.jpg";